// extracted by mini-css-extract-plugin
export var box = "_76-1";
export var checkboxRow = "_76-8";
export var checked = "_76-2";
export var descriptionSpacer = "_76-a";
export var disabled = "_76-3";
export var icon = "_76-6";
export var input = "_76-0";
export var labelSpacer = "_76-9";
export var medium = "_76-5";
export var small = "_76-4";
export var text = "_76-7";